import { Form, FormGroup, Label, Input, Spinner, Button } from "reactstrap";
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link, useLocation, NavLink } from "react-router-dom";
import { validZipCode, validate } from "helpers/validations";
import Modal from "react-bootstrap/Modal";
// import {toastr} from "toastr";

import ReCAPTCHA from "react-google-recaptcha";

// Components
import SwitchInp from "Component/SwitchInp/SwitchInp";

// Validation Helpers
import { validateEmail } from "helpers/EmailValidation";

// Store
import { registerUser, getContentPage, uploadFile, postNewCollection } from "store/actions";
import { validatePassword } from "helpers/passwordValidation";
import VerifyEmail from "helpers/VerifyEmail";
import Termscenter from "Pages/Terms/Termscenter";
import Privacycenter from "Pages/Privacypolicy/Privacycenter";
import toastr from "toastr";
import Serviceagreement from "Pages/serviceAgreement/Serviceagreement";
import { Experimental_CssVarsProvider } from "@mui/material";
import Privadoqr from "Pages/Privadosc/Privadoqr";

export default function FineRegistration() {
  const [isPrivado, setIsPrivado] = useState('')
  const location = useLocation()
  const [OpenPrivado, setOpenPrivado] = useState(false)
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [text, setText] = useState("");
  const maxCharacterCount = 60;
  const { settings } = useSelector((state) => state?.Login);
  const { loading } = useSelector((state) => state?.Register);
  const [fieldsError, setfieldsError] = useState();
  const [isVerified, setIsVerified] = useState(false);
  const [show, setShow] = useState(false);
  const [verifyStatus, setVerifyStatus] = useState(false);
  const [termOfUse, settermOfUse] = useState(false);
  const [privacypolicy, setprivacypolicy] = useState(false);
  const [serviceAgree, setserviceAgree] = useState(false);
  const [museumDescription, setmuseumDescription] = useState("");
  const maxCharacterCountmuseum = 2500;

  const [Termandcondition, setTermandcondition] = useState({
    tnc: false,
  });
  const [term, setTerm] = useState({
    tcs: false,
  });
  const [privacyPolicy, setPrivacyPolicy] = useState({
    pps: false,
  });
  const [passwordtype, setPasswordType] = useState("password");
  const [passwordtype2, setPasswordType2] = useState("password");
  const pass = () => {
    if (passwordtype === "password") {
      setPasswordType("text")
      return;
    }
    setPasswordType("password")
  }
  const confirmpass = () => {
    if (passwordtype2 === "password") {
      setPasswordType2("text")
      return;
    }
    setPasswordType2("password")
  }
  const [fields, setFields] = useState({
    name: "",
    lastname: "",
    profileImage: "",
    gender: "",
    age: "",
    role: "USER",
    address: "",
    city: "",
    email: "",
    mobileNumber: "",
    password: "",
    confirmpassword: "",
    zipcode: "",
    state: "",
    country: "",
    description: "",
    zipcodeError: false,
    refree_referral_code: ""
  });


  const { content } = useSelector((state) => state?.contentpage);
  useEffect(() => {
    if (location.state && location.state.signUpwithPrivado) {

      setIsPrivado(location.state.signUpwithPrivado)
    }

  }, [location])
  const getContent = () => {
    return content?.length && content?.find((item) => item?.slug === "platform-as-a-service-agreement")?.content;

  }

  useEffect(() => {
    dispatch(getContentPage());

    if (localStorage.getItem("referral_code")) {

      setFields((prev) => ({ ...prev, [name + "Error"]: false, refree_referral_code: localStorage.getItem("referral_code") })
      );
    }

  }, []);

  const {
    name,
    nameError,
    lastname,
    lastnameError,
    address,
    addressError,
    profileImage,
    profileImageError,
    city,
    cityError,
    email,
    emailError,
    mobileNumber,
    mobileNumberError,
    role,
    gender,
    genderError,
    age,
    ageError,
    state,
    stateError,
    password,
    confirmpassword,
    passwordError,
    confirmpasswordError,
    zipcode,
    zipcodeError,
    country,
    countryError,
    description,
    descriptionError,
    refree_referral_code
  } = fields;

  // useEffect(() => {
  //   if (Termandcondition.tnc) {
  //     setShow(true);
  //   }
  // }, [Termandcondition.tnc]);

  const onChangeHandler = (e) => {
    e.persist();
    const { value, name } = e.target;


    // if(fields?.password)
    if ((name == 'address') && (value.length <= maxCharacterCount)) {
      setText(value);
    }
    if ((name == 'description') && (value.length <= maxCharacterCountmuseum)) {
      setmuseumDescription(value);
    }
    // if ((name == 'referral_code')) {
    //   setReferralCode(value)
    // }
    setFields((prev) =>
      value !== "" || undefined || null
        ? { ...prev, [name + "Error"]: false, [name]: value }
        : { ...prev, [name + "Error"]: true, [name]: value }
    );

    setfieldsError((prev) => ({ ...prev, StateError: false }));
  };

  const uploadFileSuccess = (name) => (response) => {
    const { _id, link, message } = response.data;
    setFields((prev) => ({ ...prev, profileImage: _id }));
    setfieldsError((prev) => ({ ...prev, mediaError: false }));
    // toastr.success(message);
    onChangeHandler(name)({ target: { value: _id } });
    if (name === "media") setFields((prev) => ({ ...prev, imgType: link }));
  };

  const handleImageChange = (name) => (evt) => {
    const image = evt.target.files;
    const ext = image[0].name.split(".").pop();
    if (
      ext !== "png" &&
      ext !== "jpg" &&
      ext !== "jpeg"

    ) {
      return toastr.error("Only png, jpg extensions allowed");

    }
    if (image[0] && image[0].size >= 1.04e6 + 24) {
      toastr.error("Please upload a file smaller than 1 MB");
      return false;
    }
    if (image && image[0]) {
      dispatch(uploadFile({ image: image[0] }, uploadFileSuccess("media")));
      setFields((prevState) => ({
        ...prevState,
        imagePreview: URL.createObjectURL(image[0]),
        imageRaw: image[0],
        fileType: evt.target.files[0].type,
        profileImage: image[0],
      }));
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();

    let response = validate(fields);
    setFields((prev) => ({ ...prev, ...response }));
    if (!fields?.profileImage) {
      setFields((prev) => ({ ...prev, profileImage: "653a0ed7cc09d1064302c8bf" }));

    }
    if (fields?.name.trim() === '') {
      return toastr.error("First name is required");

    }
    if (fields?.lastname.trim() === '') {
      return toastr.error("Last name is required");
    }

    if (fields?.mobileNumber.trim() === '') {
      return toastr.error("Phone number is required");
    }
    if (fields?.mobileNumber?.length < 10) {
      return toastr.error("Phone number must be at least 10 numbers");
    }
    if (fields?.email.trim() === '') {
      return toastr.error("Email is required");
    }
    if (!validateEmail(fields?.email)) {
      toastr.error("Email is not valid.");
      return;
    }

    if (fields?.gender.trim() === '') {
      return toastr.error("Gender is required");
    }
    if (fields?.age.trim() === '') {
      return toastr.error("Age is required");
    }
    if (fields?.age < 18) {
      return toastr.error("Age should be minimum 18 year");
    }

    if (fields?.password.trim() === '') {
      return toastr.error("Password is required");
    }
    if (!validatePassword(fields?.password)) {
      toastr.error("Password should be a minimum of 6 characters, it must include a lower case, upper case and a special character along with a number.");
      return;
    }

    if (fields?.confirmpassword.trim() === '') {
      return toastr.error("Confirm password is required");
    }
    if (fields?.password !== fields?.confirmpassword) {
      return toastr.error("Confirm password does not match");
    }


    if (fields?.address.trim() === '') {
      return toastr.error("Address is required");
    }
    if (fields?.country.trim() === '') {
      return toastr.error("Country is required");
    }
    if (fields?.state.trim() === '') {
      return toastr.error("State is required");
    }
    if (fields?.city.trim() === '') {
      return toastr.error("City is required");
    }

    if (fields?.zipcode?.length < 1) {
      setFields((p) => ({ ...p, zipcodeError: true }))
      return toastr.error("Zip code is required");
    }
    if (fields?.zipcode?.length > 9) {
      setFields((p) => ({ ...p, zipcodeError: true }))
      return toastr.error("Zip code should not be greater then 9 characters");
    }
    if (!validZipCode(fields?.zipcode)) {
      setFields((p) => ({ ...p, zipcodeError: true }))
      return toastr.error("Special characters are not allowed in zip code")
    }
    if (fields?.description.trim() === '') {
      return toastr.error("Description is required")
    }

    if (isVerified) {
      setShow(true);
    } else {
      toastr.error("Please verify that you are not a robot.");
    }
  };

  function closedialogBox() {
    setVerifyStatus(false)
    navigate("/login");
  }

  function handleVerify(response) {
    if (response) {
      setIsVerified(true);
    } else {
      setIsVerified(false);
    }
  }

  function termsAndCon() {
    setShow(true);
  }

  const handleClose = () => {
    setShow(false);
  };

  const finalSubmit = () => {
    if (Termandcondition?.tnc === false) {
      return toastr.error("Please Accept Terms&Condition");
    }
    const Registerdata = {
      name: name?.trim(),
      lastname: lastname?.trim(),
      role: "USER",
      gender,
      age,
      address: address?.trim(),
      profileImage,
      city: city?.trim(),
      email,
      username: email,
      mobileNumber,
      password,
      zipcode,
      state: state?.trim(),
      country,
      description,
      verificationProfileStatus: "accept",
      refree_referral_code
    };

    const callback = (res) => {
      const { message, status } = res;
      if (status === "failure") {
        toastr.error(message);
        setShow(false);

      } else {
        if (location.state && location.state.signUpwithPrivado === "privado") {
          setOpenPrivado(!OpenPrivado)
        }
        const colletctiondata = {
          name: name?.trim() + " collection",
          description: "Explore NFTs",
          status: true,
          email: email,
          image: profileImage
        }
        const collcallback = (res) => { }

        dispatch(
          postNewCollection(colletctiondata, collcallback)
        );
        setVerifyStatus(true);
        setShow(false);

      }
    };
    dispatch(registerUser(Registerdata, callback));

  };
  function removeImage() {
    setFields((prevState) => ({
      ...prevState,
      imagePreview: "",
      imageRaw: "",
      fileType: "",
      profileImage: ""
    }));
  }

  function termofService() {
    settermOfUse(true)
  }
  function privacyPolicycont() {
    setprivacypolicy(true)
  }
  function serviceag() {
    setserviceAgree(true)
  }
  function closeTerms() {
    settermOfUse(false)
    setprivacypolicy(false)
    setserviceAgree(false)

  }
  useEffect(() => {
    document.querySelectorAll('textarea').forEach((el) => {
      el.style.height = el.setAttribute('style', 'height: ' + el.scrollHeight + 'px');
      el.classList.add('auto');
      el.addEventListener('input', e => {
        el.style.height = 'auto';
        el.style.height = (el.scrollHeight) + 'px';
      })
    })
  }, [])

  const Privado = () => {
    if (location.state && location.state.signUpwithPrivado === "privado") {
      setOpenPrivado(!OpenPrivado)
    }
  }
  return (
    <>
      <div className="artist-div">
        <Modal className="artist-modal" size="lg" show={show} centered animation={false}>
          <form>
            <div className="term_userdiv ">
              <div className="term-content-container">
                <div
                  dangerouslySetInnerHTML={{
                    __html: getContent()
                      ? getContent()
                      : "Loading...",
                  }}
                />


                <div className="CustomeCheckBox mb-2">
                  <SwitchInp
                    enabled={Termandcondition?.tnc}
                    handleChangeFun={setTermandcondition}
                    name="tnc" id="tnc"
                  /> <label htmlFor="tnc"></label>

                  <span onClick={serviceag} className="link_text mb-0 cursor-pointer" >  I agree platform as a service agreement</span>


                </div>
                <div className="CustomeCheckBox mb-2">
                  <SwitchInp
                    enabled={term?.tcs}
                    handleChangeFun={setTerm}
                    name="tcs" id="tcs"
                  />  <label htmlFor="tcs"></label>
                  <span onClick={termofService} className="link_text mb-0 cursor-pointer" >I agree, terms of service</span>

                </div>

                <div className="CustomeCheckBox mb-2">
                  <SwitchInp
                    enabled={privacyPolicy.pps}
                    handleChangeFun={setPrivacyPolicy}
                    name="pps" id="pps"
                  /> <label htmlFor="pps"></label>
                  <span onClick={privacyPolicycont} className="link_text mb-0 cursor-pointer" >I agree, privacy policy</span>
                </div>
              </div>


              <div className="termsBtn">
                <div className="textscrollmsg mb-3">
                  <div className="scrollIcon">
                    <i className="fa-light fa-angles-down"></i>
                  </div>
                  <p className="mb-0">Please scroll below  to check all agreement before accepting</p>
                </div>
                <Button
                  variant="danger"
                  className="cancel_btn"
                  onClick={handleClose}
                >
                  Close
                </Button>
                <Button
                  variant="secondary"
                  className="success_btn"
                  onClick={finalSubmit}
                  disabled={!Termandcondition?.tnc || !term?.tcs || !privacyPolicy?.pps}
                >
                  Accept
                </Button>
              </div>
            </div>
          </form>
        </Modal>

      </div>
      <Modal className="termandCoDialog" show={serviceAgree} centered animation={false}>
        <div className="text-end">
          <button onClick={closeTerms} className="btn cancelbtn end-0 top-0"><img src="/images/svg/closeIconDialog.svg" alt="" /></button>
        </div>
        <div className="contentBoxdialog">
          <Serviceagreement />
          {content && <button className="btn btn-primary px-5 btn-sm py-2" onClick={closeTerms}>Back</button>}
        </div>

      </Modal>
      <Modal className="termandCoDialog" show={termOfUse} centered animation={false}>
        <div className="text-end">
          <button onClick={closeTerms} className="btn cancelbtn end-0 top-0"><img src="/images/svg/closeIconDialog.svg" alt="" /></button>
        </div>
        <div className="contentBoxdialog">
          <Termscenter />
          {content && <button className="btn btn-primary px-5 btn-sm py-2" onClick={closeTerms}>Back</button>}
        </div>

      </Modal>
      <Modal className="termandCoDialog" show={privacypolicy} centered animation={false}>
        <div className="text-end">
          <button onClick={closeTerms} className="btn cancelbtn end-0 top-0"><img src="/images/svg/closeIconDialog.svg" alt="" /></button>
        </div>
        <div className="contentBoxdialog">
          <Privacycenter />
          {content && <button className="btn btn-primary px-5 btn-sm py-2" onClick={closeTerms}>Back</button>}
        </div>
      </Modal>
      <Modal className="EmailVerifyBoxModel text-center" size="md" show={verifyStatus} centered animation={false}>
        <VerifyEmail />
        <button className="btn btn-primary btn-sm py-2 text-white" onClick={closedialogBox}>Close</button>
      </Modal>

      <section className="container-fluid user-register-page p-0">
        <div className="row g-0 min-vh-100">

          {/* LEFT IMAGE — EXISTING IMAGE PATH IS UNCHANGED */}
          <Col
            lg={7}
            className="user-register-image-column d-none d-lg-block p-0"
          >
            <div className="user-register-image-wrapper">
              <img
                src="../../images/userSignUp.png"
                className="user-register-image"
                alt="User registration"
              />
            </div>
          </Col>

          {/* RIGHT FORM SECTION */}
          <Col
            xs={12}
            lg={5}
            className="user-register-form-column bg-white p-0"
          >
            <div className="user-register-scroll">
              <div className="user-register-content mx-auto px-3 px-sm-4 px-xl-5 py-4 py-lg-5">

                {/* Logo */}
                <div className="user-register-logo text-center mb-3">
                  <a
                    href="https://terpnash.com/"
                    rel="noreferrer"
                    className="navbar-brand d-inline-block p-0 m-0"
                  >
                    {settings?.logo?.link && (
                      <>
                        {settings?.logo?.link.search(".mp4") !== -1 ? (
                          <img
                            src={settings?.logo?.link || "/images/t3.gif"}
                            alt="Terpnash logo"
                            className="img-fluid"
                          />
                        ) : (
                          <img
                            src={settings?.logo?.link || "/images/t3.gif"}
                            alt="Terpnash logo"
                            className="img-fluid logodesktop"
                          />
                        )}
                      </>
                    )}
                  </a>
                </div>

                {/* Header */}
                <div className="text-center mb-4">
                  <h1 className="user-register-title  mb-2 LR-heading">
                    Create your Account
                  </h1>

                  <p className="user-register-subtitle LR-subheading mb-4">
                    Join artists, museums and Collectors from around the world
                  </p>

                  <h5 className="user-account-heading LR-heading mb-3">
                    Choose your account type
                  </h5>

                  {/* Account tabs */}
                  <div className="user-account-tabs d-flex align-items-center p-1">
                    <NavLink
                      className={({ isActive }) =>
                        `user-account-tab flex-fill ${isActive ? "active gardient-button" : ""
                        }`
                      }
                      to="/users/register"
                      state={{ signUpwithPrivado: isPrivado }}
                    >
                      Buyer
                    </NavLink>

                    <NavLink
                      className={({ isActive }) =>
                        `user-account-tab flex-fill ${isActive ? "active gardient-button" : ""
                        }`
                      }
                      to="/artist/register"
                      state={{ signUpwithPrivado: isPrivado }}
                    >
                      Artist
                    </NavLink>

                    <NavLink
                      className={({ isActive }) =>
                        `user-account-tab flex-fill ${isActive ? "active gardient-button" : ""
                        }`
                      }
                      to="/museums/register"
                      state={{ signUpwithPrivado: isPrivado }}
                    >
                      Museum
                    </NavLink>
                  </div>
                </div>

                <Form className="registration-here">

                  {/* BASIC INFORMATION */}
                  <div className="user-form-section mb-1">
                    <h2 className="user-section-title LR-heading mb-0">
                      Basic Information
                    </h2>

                    {/* Profile image */}
                    <div className="d-flex flex-column align-items-center text-center user-upload-profile-gap">
                      {fields?.imagePreview ? (
                        <div className="position-relative">
                          <button
                            type="button"
                            className="user-profile-remove btn p-0 position-absolute"
                            onClick={removeImage}
                            aria-label="Remove profile image"
                          >
                            <i className="fa-regular fa-xmark"></i>
                          </button>

                          <label
                            htmlFor="inputGroupFile01"
                            className="user-profile-upload overflow-hidden"
                          >
                            <img
                              src={
                                fields?.imagePreview ||
                                "img/upload-img.png"
                              }
                              className="w-100 h-100"
                              alt="Profile preview"
                            />
                          </label>

                          <input
                            className="d-none"
                            name="profileImage"
                            type="file"
                            id="inputGroupFile01"
                            onChange={handleImageChange("profileImage")}
                            accept="image/*"
                          />
                        </div>
                      ) : (
                        <>
                          <label
                            htmlFor="inputGroupFile01"
                            className="user-profile-upload"
                          >
                            <i className="fa-regular fa-camera"></i>
                          </label>

                          <input
                            className="d-none"
                            name="image"
                            type="file"
                            id="inputGroupFile01"
                            onChange={handleImageChange("image")}
                            accept="image/*"
                          />
                        </>
                      )}

                      <p className="user-upload-title mt-3 mb-1 LR-subheading">
                        Upload Profile Photo
                      </p>

                      <p className="user-upload-description mb-0 LR-subheading">
                       Click to upload an image · JPG / PNG up to 1MB
                      </p>
                    </div>

                    <Row className="g-6">

                      {/* First name */}
                      <Col xs={12} md={6}>
                        <FormGroup className="mb-0">
                          <Label
                            htmlFor="name"
                            className="user-form-label LR-subheading"
                          >
                            First Name
                          </Label>

                          <Input
                            type="text"
                            placeholder="First Name"
                            name="name"
                            id="name"
                            value={name}
                            invalid={nameError}
                            required={nameError}
                            onChange={onChangeHandler}
                            maxLength={30}
                            className="user-form-control"
                          />
                        </FormGroup>
                      </Col>

                      {/* Last name */}
                      <Col xs={12} md={6}>
                        <FormGroup className="mb-0">
                          <Label
                            htmlFor="lastname"
                            className="user-form-label LR-subheading"
                          >
                            Last Name
                          </Label>

                          <Input
                            type="text"
                            placeholder="Last Name"
                            name="lastname"
                            id="lastname"
                            value={lastname}
                            invalid={lastnameError}
                            required={lastnameError}
                            onChange={onChangeHandler}
                            maxLength={30}
                            className="user-form-control"
                          />
                        </FormGroup>
                      </Col>

                      {/* Phone */}
                      <Col xs={12} md={6}>
                        <FormGroup className="mb-0">
                          <Label
                            htmlFor="mobileNumber"
                            className="user-form-label LR-subheading"
                          >
                            Phone Number
                          </Label>

                          <Input
                            type="number"
                            maxLength={11}
                            placeholder="Phone Number"
                            min="1"
                            name="mobileNumber"
                            id="mobileNumber"
                            value={mobileNumber}
                            invalid={mobileNumberError}
                            required={mobileNumberError}
                            onChange={onChangeHandler}
                            className="user-form-control"
                          />
                        </FormGroup>
                      </Col>

                      {/* Email */}
                      <Col xs={12} md={6}>
                        <FormGroup className="mb-0">
                          <Label
                            htmlFor="email"
                            className="user-form-label LR-subheading"
                          >
                            Email
                          </Label>

                          <Input
                            pattern={
                              fields?.email === ".+@gmail.com" ||
                              fields?.email === ".com"
                            }
                            placeholder="Email"
                            type="email"
                            name="email"
                            id="email"
                            value={email}
                            invalid={emailError}
                            required={emailError}
                            onChange={onChangeHandler}
                            className="user-form-control"
                          />
                        </FormGroup>
                      </Col>

                      {/* Gender */}
                      <Col xs={12} md={6}>
                        <FormGroup className="mb-0">
                          <Label
                            htmlFor="gender"
                            className="user-form-label LR-subheading"
                          >
                            Select Gender
                          </Label>

                          <Input
                            type="select"
                            name="gender"
                            id="gender"
                            value={gender}
                            invalid={genderError}
                            required={genderError ? genderError : true}
                            onChange={onChangeHandler}
                            className="user-form-control form-select"
                          >
                            <option value="" disabled>
                              Select Gender
                            </option>

                            <option>Male</option>
                            <option>Female</option>
                            <option>Prefer Not to Say</option>
                          </Input>
                        </FormGroup>
                      </Col>

                      {/* Age */}
                      <Col xs={12} md={6}>
                        <FormGroup className="mb-0">
                          <Label
                            htmlFor="age"
                            className="user-form-label LR-subheading"
                          >
                            Age
                          </Label>

                          <Input
                            type="number"
                            placeholder="Age"
                            name="age"
                            id="age"
                            value={age}
                            invalid={ageError}
                            required={ageError}
                            onChange={onChangeHandler}
                            className="user-form-control"
                          />
                        </FormGroup>
                      </Col>

                      {/* Password */}
                      <Col xs={12} md={6}>
                        <FormGroup className="mb-0">
                          <Label
                            htmlFor="password"
                            className="user-form-label LR-subheading"
                          >
                            Password
                          </Label>

                          <div className="position-relative">
                            <Input
                              placeholder="Password"
                              type={passwordtype}
                              name="password"
                              id="password"
                              value={password}
                              invalid={passwordError}
                              required={passwordError}
                              onChange={onChangeHandler}
                              className="user-form-control pe-5"
                            />

                            <button
                              type="button"
                              onClick={pass}
                              className="user-password-button btn border-0 position-absolute"
                              aria-label="Toggle password visibility"
                            >
                              {passwordtype === "password" ? (
                                <i className="fa-light fa-eye-slash"></i>
                              ) : (
                                <i className="fa-light fa-eye"></i>
                              )}
                            </button>
                          </div>
                        </FormGroup>
                      </Col>

                      {/* Confirm password */}
                      <Col xs={12} md={6}>
                        <FormGroup className="mb-0">
                          <Label
                            htmlFor="confirmpassword"
                            className="user-form-label LR-subheading"
                          >
                            Confirm Password
                          </Label>

                          <div className="position-relative">
                            <Input
                              placeholder="Confirm Password"
                              type={passwordtype2}
                              name="confirmpassword"
                              id="confirmpassword"
                              value={confirmpassword}
                              invalid={confirmpasswordError}
                              required={confirmpasswordError}
                              onChange={onChangeHandler}
                              className="user-form-control pe-5"
                            />

                            <button
                              type="button"
                              onClick={confirmpass}
                              className="user-password-button btn border-0 position-absolute"
                              aria-label="Toggle confirm-password visibility"
                            >
                              {passwordtype2 === "password" ? (
                                <i className="fa-light fa-eye-slash"></i>
                              ) : (
                                <i className="fa-light fa-eye"></i>
                              )}
                            </button>
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>

                  {/* ADDRESS */}
                  <div className="user-form-section mb-1">
                    <h2 className="user-section-title-log LR-heading mb-3">
                      Address
                    </h2>

                    <Row className="g-6">

                      {/* Full address */}
                      <Col xs={12}>
                        <FormGroup className="mb-0">
                          <Label
                            htmlFor="address"
                            className="user-form-label LR-subheading"
                          >
                            Full Address
                          </Label>

                          <div className="position-relative">
                            <Input
                              type="textarea"
                              maxLength={60}
                              className="user-form-control user-address-control pb-4"
                              value={address}
                              placeholder="Full Address"
                              invalid={addressError}
                              name="address"
                              id="address"
                              required={addressError}
                              onChange={onChangeHandler}
                            />

                            <span className="user-character-count">
                              {maxCharacterCount - text.length}/
                              {maxCharacterCount}
                            </span>
                          </div>
                        </FormGroup>
                      </Col>

                      {/* City */}
                      <Col xs={12} md={6}>
                        <FormGroup className="mb-0">
                          <Label
                            htmlFor="city"
                            className="user-form-label LR-subheading"
                          >
                            City
                          </Label>

                          <Input
                            type="text"
                            name="city"
                            id="city"
                            placeholder="City"
                            value={city}
                            invalid={cityError}
                            required={cityError}
                            onChange={onChangeHandler}
                            className="user-form-control"
                          />
                        </FormGroup>
                      </Col>

                      {/* State */}
                      <Col xs={12} md={6}>
                        <FormGroup className="mb-0">
                          <Label
                            htmlFor="state"
                            className="user-form-label LR-subheading"
                          >
                            State
                          </Label>

                          <Input
                            type="text"
                            name="state"
                            id="state"
                            placeholder="State"
                            value={state}
                            invalid={stateError}
                            required={stateError}
                            onChange={onChangeHandler}
                            className="user-form-control"
                          />
                        </FormGroup>
                      </Col>

                      {/* Country */}
                      <Col xs={12} md={6}>
                        <FormGroup className="mb-0">
                          <Label
                            htmlFor="country"
                            className="user-form-label LR-subheading"
                          >
                            Country
                          </Label>

                          <Input
                            type="select"
                            name="country"
                            id="country"
                            value={country}
                            invalid={countryError}
                            required
                            onChange={onChangeHandler}
                            className="user-form-control form-select"
                          >
                            <option value="" disabled>
                              Select Country
                            </option>
                          <option value="Afghanistan">Afghanistan</option>
                          <option value="Albania">Albania</option>
                          <option value="Algeria">Algeria</option>
                          <option value="American Samoa">American Samoa</option>
                          <option value="Andorra">Andorra</option>
                          <option value="Angola">Angola</option>
                          <option value="Anguilla">Anguilla</option>
                          <option value="Antigua">Antigua</option>
                          <option value="Argentina">Argentina</option>
                          <option value="Armenia">Armenia</option>
                          <option value="Aruba">Aruba</option>
                          <option value="Australia">Australia</option>
                          <option value="Austria">Austria</option>
                          <option value="Azerbaijan">Azerbaijan</option>
                          <option value="Bahrain">Bahrain</option>
                          <option value="Bangladesh">Bangladesh</option>
                          <option value="Barbados">Barbados</option>

                          <option value="Burkina Faso">Burkina Faso</option>
                          <option value="Brazil">Brazil</option>
                          <option value="Belarus">Belarus</option>
                          <option value="Brazil">Brazil</option>
                          <option value="Belarus">Belarus</option>
                          <option value="Belgium">Belgium</option>
                          <option value="Belize">Belize</option>
                          <option value="Benin">Benin</option>
                          <option value="Bermuda">Bermuda</option>
                          <option value="Bhutan">Bhutan</option>
                          <option value="Bolivia">Bolivia</option>
                          <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
                          <option value="Botswana">Botswana</option>
                          <option value="Bulgaria">Bulgaria</option>
                          <option value="Burundi">Burundi</option>

                          <option value="Bonaire, Sint Eustatius and Saba">Bonaire, Sint Eustatius and Saba</option>
                          <option value="British Virgin Islands">British Virgin Islands</option>
                          <option value="British Indian Ocean Territory">British Indian Ocean Territory</option>
                          <option value="Brunei">Brunei</option>

                          <option value="Côte d'Ivoire">Côte d'Ivoire</option>
                          <option value="Central African Republic">Central African Republic</option>
                          <option value="China">China</option>
                          <option value="Chad">Chad</option>
                          <option value="Chile">Chile</option>
                          <option value="Curaçao">Curaçao</option>
                          <option value="Croatia">Croatia</option>
                          <option value="Cape Verde">Cape Verde</option>
                          <option value="Colombia">Colombia</option>
                          <option value="Costa Rica">Costa Rica</option>
                          <option value="Cuba">Cuba</option>
                          <option value="Canada">Canada</option>
                          <option value="Cambodia">Cambodia</option>
                          <option value="Cook Islands">Cook Islands</option>
                          <option value="Czech Republic">Czech Republic</option>
                          <option value="Cayman Islands">Cayman Islands</option>
                          <option value="Comoros">Comoros</option>
                          <option value="Cyprus">Cyprus</option>
                          <option value="Denmark">Denmark</option>
                          <option value="Djibouti">Djibouti</option>
                          <option value="Dominican Republic">Dominican Republic</option>
                          <option value="Dominica">Dominica</option>
                          <option value="Democratic Republic of the Congo">Democratic Republic of the Congo</option>
                          <option value="Egypt">Egypt</option>
                          <option value="Ethiopia">Ethiopia</option>
                          <option value="Estonia">Estonia</option>
                          <option value="Ecuador">Ecuador</option>
                          <option value="El Salvador">El Salvador</option>
                          <option value="Eritrea">Eritrea</option>
                          <option value="Equatorial Guinea">Equatorial Guinea</option>
                          <option value="France">France</option>
                          <option value="French Guiana">French Guiana</option>
                          <option value="French Polynesia">French Polynesia</option>
                          <option value="Fiji">Fiji</option>
                          <option value="Finland">Finland</option>
                          <option value="Falkland Islands">Falkland Islands</option>
                          <option value="Faroe Islands">Faroe Islands</option>
                          <option value="Federated States of Micronesia">Federated States of Micronesia</option>
                          <option value="Georgia">Georgia</option>
                          <option value="Grenada">Grenada</option>
                          <option value="Greenland">Greenland</option>
                          <option value="Guadeloupe">Guadeloupe</option>
                          <option value="Guam">Guam</option>
                          <option value="Guernsey">Guernsey</option>
                          <option value="Guyana">Guyana</option>
                          <option value="Ghana">Ghana</option>
                          <option value="Guinea">Guinea</option>
                          <option value="Gabon">Gabon</option>
                          <option value="Guatemala">Guatemala</option>
                          <option value="Greece">Greece</option>
                          <option value="Gibraltar">Gibraltar</option>
                          <option value="Guinea-Bissau">Guinea-Bissau</option>
                          <option value="Haiti">Haiti</option>
                          <option value="Honduras">Honduras</option>
                          <option value="Hong Kong">Hong Kong</option>
                          <option value="Hungary">Hungary</option>
                          <option value="Iceland">Iceland</option>
                          <option value="Isle Of Man">Isle Of Man</option>
                          <option value="Iran">Iran</option>
                          <option value="Italy">Italy</option>
                          <option value="Iraq">Iraq</option>
                          <option value="India">India</option>
                          <option value="Israel">Israel</option>
                          <option value="Indonesia">Indonesia</option>
                          <option value="Ireland">Ireland</option>
                          <option value="Jordan">Jordan</option>
                          <option value="Jamaica">Jamaica</option>
                          <option value="Jersey">Jersey</option>
                          <option value="Japan">Japan</option>
                          <option value="Kenya">Kenya</option>
                          <option value="Kiribati">Kiribati</option>
                          <option value="Kazakhstan">Kazakhstan</option>
                          <option value="Kyrgyzstan">Kyrgyzstan</option>
                          <option value="Kuwait">Kuwait</option>
                          <option value="Kosovo">Kosovo</option>
                          <option value="Lithuania">Lithuania</option>
                          <option value="Liberia">Liberia</option>
                          <option value="Libya">Libya</option>
                          <option value="Latvia">Latvia</option>
                          <option value="Lesotho">Lesotho</option>
                          <option value="Laos">Laos</option>
                          <option value="Lebanon">Lebanon</option>
                          <option value="Liechtenstein">Liechtenstein</option>
                          <option value="Luxembourg">Luxembourg</option>
                          <option value="Macau">Macau</option>
                          <option value="Maldives">Maldives</option>
                          <option value="Malta">Malta</option>
                          <option value="Malawi">Malawi</option>
                          <option value="Malaysia">Malaysia</option>
                          <option value="Montenegro">Montenegro</option>
                          <option value="Mali">Mali</option>
                          <option value="Macedonia">Macedonia</option>
                          <option value="Marshall Islands">Marshall Islands</option>
                          <option value="Martinique">Martinique</option>
                          <option value="Mayotte">Mayotte</option>
                          <option value="Mauritius">Mauritius</option>
                          <option value="Mauritania">Mauritania</option>
                          <option value="Mongolia">Mongolia</option>
                          <option value="Montserrat">Montserrat</option>
                          <option value="Myanmar">Myanmar</option>
                          <option value="Moldova">Moldova</option>
                          <option value="Morocco">Morocco</option>
                          <option value="Monaco">Monaco</option>
                          <option value="Mexico">Mexico</option>
                          <option value="Mozambique">Mozambique</option>
                          <option value="Madagascar">Madagascar</option>
                          <option value="Northern Mariana Islands">Northern Mariana Islands</option>
                          <option value="North Korea">North Korea</option>
                          <option value="New Zealand">New Zealand</option>
                          <option value="New Caledonia">New Caledonia</option>
                          <option value="Norway">Norway</option>
                          <option value="Nauru">Nauru</option>
                          <option value="Namibia">Namibia</option>
                          <option value="Nepal">Nepal</option>
                          <option value="Nicaragua">Nicaragua</option>
                          <option value="Niger">Niger</option>
                          <option value="Norfolk Island">Norfolk Island</option>
                          <option value="Netherlands">Netherlands</option>
                          <option value="Nigeria">Nigeria</option>
                          <option value="Niue">Niue</option>
                          <option value="Oman">Oman</option>
                          <option value="Portugal">Portugal</option>
                          <option value="Peru">Peru</option>
                          <option value="Palau">Palau</option>
                          <option value="Poland">Poland</option>
                          <option value="Paraguay">Paraguay</option>
                          <option value="Pakistan">Pakistan</option>
                          <option value="Panama">Panama</option>
                          <option value="Philippines">Philippines</option>
                          <option value="Palestine">Palestine</option>
                          <option value="Puerto Rico">Puerto Rico</option>
                          <option value="Papua New Guinea">Papua New Guinea</option>
                          <option value="Qatar">Qatar</option>
                          <option value="Republic of the Congo">Republic of the Congo</option>
                          <option value="Russia">Russia</option>
                          <option value="Réunion">Réunion</option>
                          <option value="Rwanda">Rwanda</option>
                          <option value="Romania">Romania</option>
                          <option value="Saint Pierre and Miquelon">Saint Pierre and Miquelon</option>
                          <option value="Saint Helena">Saint Helena</option>
                          <option value="Saint Martin">Saint Martin</option>
                          <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
                          <option value="Sint Maarten">Sint Maarten</option>
                          <option value="San Marino">San Marino</option>
                          <option value="Saint Vincent and the Grenadines">Saint Vincent and the Grenadines</option>
                          <option value="Sri Lanka">Sri Lanka</option>
                          <option value="Slovakia">Slovakia</option>
                          <option value="Slovenia">Slovenia</option>
                          <option value="Sudan">Sudan</option>
                          <option value="Swaziland">Swaziland</option>
                          <option value="Sweden">Sweden</option>
                          <option value="Switzerland">Switzerland</option>
                          <option value="South Africa">South Africa</option>
                          <option value="South Sudan">South Sudan</option>
                          <option value="Samoa">Samoa</option>
                          <option value="Serbia">Serbia</option>
                          <option value="Sierra Leone">Sierra Leone</option>
                          <option value="Senegal">Senegal</option>
                          <option value="Seychelles">Seychelles</option>
                          <option value="Saudi Arabia">Saudi Arabia</option>
                          <option value="Saint Barthélemy">Saint Barthélemy</option>
                          <option value="Suriname">Suriname</option>
                          <option value="Solomon Islands">Solomon Islands</option>
                          <option value="Somalia">Somalia</option>
                          <option value="Saint Lucia">Saint Lucia</option>
                          <option value="South Korea">South Korea</option>
                          <option value="Sao Tome and Principe">Sao Tome and Principe</option>
                          <option value="Singapore">Singapore</option>
                          <option value="Syria">Syria</option>
                          <option value="Spain">Spain</option>
                          <option value="The Bahamas">The Bahamas</option>
                          <option value="The Gambia">The Gambia</option>
                          <option value="Timor-Leste">Timor-Leste</option>
                          <option value="Taiwan">Taiwan</option>
                          <option value="Tajikistan">Tajikistan</option>
                          <option value="Thailand">Thailand</option>
                          <option value="Tonga">Tonga</option>
                          <option value="Tanzania">Tanzania</option>
                          <option value="Trinidad and Tobago">Trinidad and Tobago</option>
                          <option value="Turks and Caicos Islands">Turks and Caicos Islands</option>
                          <option value="Tunisia">Tunisia</option>
                          <option value="Tuvalu">Tuvalu</option>
                          <option value="Turkey">Turkey</option>
                          <option value="Tokelau">Tokelau</option>
                          <option value="Turkmenistan">Turkmenistan</option>
                          <option value="Togo">Togo</option>
                          <option value="Uganda">Uganda</option>
                          <option value="Ukraine">Ukraine</option>
                          <option value="United Arab Emirates">United Arab Emirates</option>
                          <option value="United Kingdom">United Kingdom</option>
                          <option value="United States">United States</option>
                          <option value="Uruguay">Uruguay</option>
                          <option value="Uzbekistan">Uzbekistan</option>
                          <option value="Vatican City">Vatican City</option>
                          <option value="Venezuela">Venezuela</option>
                          <option value="Vanuatu">Vanuatu</option>
                          <option value="Vietnam">Vietnam</option>
                          <option value="Wallis and Futuna">Wallis and Futuna</option>
                          <option value="Western Sahara">Western Sahara</option>
                          <option value="Yemen">Yemen</option>
                          <option value="Zambia">Zambia</option>
                          <option value="Zimbabwe">Zimbabwe</option>

                            {/*
                        KEEP YOUR COMPLETE EXISTING COUNTRY OPTIONS HERE
                        WITHOUT CHANGING THEM.

                        Start:
                        <option value="Afghanistan">Afghanistan</option>

                        End:
                        <option value="Zimbabwe">Zimbabwe</option>
                      */}
                          </Input>
                        </FormGroup>
                      </Col>

                      {/* ZIP */}
                      <Col xs={12} md={6}>
                        <FormGroup className="mb-0">
                          <Label
                            htmlFor="zipcode"
                            className="user-form-label"
                          >
                            ZIP
                          </Label>

                          <Input
                            type="text"
                            name="zipcode"
                            id="zipcode"
                            placeholder="ZIP Code"
                            maxLength={9}
                            value={zipcode}
                            invalid={fields?.zipcodeError}
                            required={fields?.zipcodeError}
                            onChange={onChangeHandler}
                            className="user-form-control"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>

                  {/* BIO */}
                  <div className="user-form-section mb-3 bio-section">
                    <Row className="">

                      <Col xs={12}>
                        <FormGroup className="mb-0">
                          <Label
                            htmlFor="description"
                            className="user-form-label LR-subheading"
                          >
                            Bio
                          </Label>

                          <div className="position-relative">
                            <Input
                              type="textarea"
                              maxLength={2500}
                              placeholder="Write here..."
                              name="description"
                              id="description"
                              value={description}
                              invalid={descriptionError}
                              required={descriptionError}
                              onChange={onChangeHandler}
                              className="user-form-control user-bio-control pb-4"
                            />

                            <span className="user-character-count">
                              {maxCharacterCountmuseum -
                                museumDescription.length}
                              /{maxCharacterCountmuseum}
                            </span>
                          </div>
                        </FormGroup>
                      </Col>

                      {/* Existing referral code remains unchanged */}
                      <Col xs={12}>
                        <FormGroup className="mb-0">
                          <Label
                            htmlFor="refree_referral_code"
                            className="user-form-label LR-subheading"
                          >
                            Referral Code
                          </Label>

                          <Input
                            type="text"
                            name="refree_referral_code"
                            id="refree_referral_code"
                            placeholder="Referral Code"
                            value={fields?.refree_referral_code}
                            onChange={onChangeHandler}
                            className="user-form-control"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>

                  {/* Existing reCAPTCHA */}
                  <div className="user-captcha-wrapper d-flex justify-content-left mb-4">
                    <ReCAPTCHA
                      sitekey={
                        settings?.googleCaptchaKey?.captchaKey ||
                        "6LfHhHgmAAAAAMDY7S-sxLljqfIE6ku1u1zYWNi2"
                      }
                      onChange={(e) => handleVerify(e)}
                    />
                  </div>

                  {/* Existing submit */}
                  <div className="text-center">
                    <button
                      onClick={onSubmit}
                      className={
                        isPrivado === "privado"
                          ? "registrationBtn user-create-account-button w-100 prevadobtnnew"
                          : "registrationBtn user-create-account-button w-100" 
                      }
                      type="submit"
                    >
                      Create Account{" "}

                      {loading ? (
                        <Spinner
                          animation="border"
                          size="sm"
                          role="status"
                        />
                      ) : (
                        ""
                      )}
                    </button>
                  </div>

                  {/* Login */}
                  <div className="text-center mt-4">
                    <p className="user-login-text mb-0">
                      Already have an account?{" "}

                      <Link
                        to="/login"
                        className="user-login-link"
                      >
                        Login
                      </Link>
                    </p>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </div>
      </section>
      {OpenPrivado == true && <div className="barcodeBoxMaine barcodeafterlogin">
        <Privadoqr func={Privado} />

      </div>}

    </>
  );
}
